export const SHOE_FINDER_IMAGES: string[] = Array.from(
	{ length: 40 },
	(_, i) => `/shoe-finder/image ${i + 7}.png`,
);
